<template>
  <ContextMenu v-if="userOptions.length" :options="userOptions" />
</template>

<script>
import { computed } from "vue";
import ContextMenu from "../ui/ContextMenu.vue";
import { useFormsStore } from "@/stores/formsStore";
import { useUsersStoreRefactor } from "@/stores/usersStoreRefactor";

export default {
  name: "UserOptions",
  components: {
    ContextMenu,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const formsStore = useFormsStore();
    const usersStore = useUsersStoreRefactor();

    const userOptions = computed(() => {
      const options = [];

      if (props.user.can_edit) {
        options.push({
          name: "Gebruiker wijzigen",
          action: () => formsStore.edit({ type: "user", item: props.user }),
          icon: "mdi-account-edit",
        });
      }

      if (props.user.can_deactivate) {
        options.push({
          name: "Gebruiker deactiveren",
          action: () => usersStore.deactivate(props.user),
          icon: "mdi-account-lock",
        });
      }

      if (props.user.can_activate) {
        options.push({
          name: "Gebruiker activeren",
          action: () => usersStore.activate(props.user),
          icon: "mdi-account-check",
        });
      }

      if (props.user.can_change_password) {
        options.push({
          name: "Wachtwoord wijzigen",
          action: () =>
            formsStore.edit({ type: "user_password", item: props.user }),
          icon: "mdi-lock-reset",
        });
      }

      return options;
    });

    return {
      userOptions,
    };
  },
};
</script>
